'use strict';

/**
 * @ngdoc function
 * @name cloudBillingLegacyFrontend.controller:EaImprintCtrl
 * @description
 * # EaImprintCtrl
 * Controller of the cloudBillingLegacyFrontend
 */
angular.module('cloudBillingLegacyFrontend').controller('EaImprintCtrl', [ function () {

}]);
